export default "__VITE_ASSET__57bc3c1c__"